// The federations shown in the "Used by" strip on the login screen. Deliberately a plain constant
// rather than an API call: it's marketing copy on the one page that renders before a user is
// authenticated, so it must not depend on a request that can fail or lag.
//
// To add a partner: drop the logo in `apps/web/public/partners/` and add a row here. Files under
// `public/` are copied to `dist/` verbatim (no import, no content hash), so `logoSrc` is the path
// the browser requests — keep the leading slash.
export interface Partner {
  /** Full federation name — used as the image alt text, and as the wordmark shown if the file 404s. */
  name: string;
  /** Path under `public/`, e.g. `/partners/hrs.png`. SVG or PNG; either way the background must be
   *  TRANSPARENT — the dark panel shows through, and a white box around the mark would be obvious. */
  logoSrc: string;
  /**
   * A white/negative version of the mark, for the dark panel. Optional: without it the panel falls
   * back to flattening `logoSrc` with a CSS filter, which is fine for a solid shape but destroys a
   * crest whose detail lives in internal contrast (see PartnerLogos).
   *
   * The files here are derived by `scripts/make-white-logos.py`. If a federation publishes its own
   * official negative logo, use that instead — their artwork beats anything derived from a colour
   * original.
   */
  logoWhiteSrc?: string;
}

export const LOGIN_PARTNERS: Partner[] = [
  {
    name: 'Hrvatski rukometni savez',
    logoSrc: '/partners/hrs.png',
    logoWhiteSrc: '/partners/hrs-white.png',
  },
  {
    name: 'Udruga hrvatskih rukometnih sudaca',
    logoSrc: '/partners/uhrs.png',
    logoWhiteSrc: '/partners/uhrs-white.png',
  },
];

// The sponsors rotated through the referee sidebar rail (SponsorRail). A global constant for now —
// the pilot runs with Croatian federations only, so every referee sees the same partners. Once a
// second country's referees come aboard this must become per-federation data, or Croatian partners
// end up advertised to referees elsewhere. An empty list falls back to the placeholder slot.
export interface Sponsor {
  /** Used as alt text and as the caption under the logo. */
  name: string;
  /** Path under `public/`; transparent background, since it sits on the surface token. Also the
   *  React key, so each sponsor needs its own file. */
  logoSrc: string;
  /** Optional click-through; opens in a new tab so the referee doesn't lose their session. */
  href?: string;
}

export const SIDEBAR_SPONSORS: Sponsor[] = [
  {
    name: 'Hrvatski rukometni savez',
    logoSrc: '/partners/hrs.png',
    href: 'https://www.hrs.hr',
  },
  {
    name: 'Croatia — Full of life',
    logoSrc: '/partners/croatia-full-of-life.png',
    href: 'https://croatia.hr',
  },
];
